import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import NavigationMenu from "./navigationMenu";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


const DesktopNav = ({ pathname }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const { getCurrentLogo } = useUserParams();

  const handleMenuHover = (menu) => {
    setActiveMenu(menu);
  };

  return (
    <div
      style={{ gridTemplateColumns: "1fr auto 1fr" }}
      className="w-full grid min-h-20 items-center"
    >
      <img src={getCurrentLogo()} alt="Logo" width={96} height={96} className="w-24" />

      <nav className="flex gap-x-12 justify-center font-mont font-semibold text-lg tracking-wide child:relative py-2">
        {constants.NAV_ITEMS.map((item) =>
          item.items.length > 0 ? (
            <div
              key={item.label}
              className="cursor-pointer pb-2 text-ocean hover:text-logo-main transition-colors duration-200"
              onMouseEnter={() => handleMenuHover(item.label)}
              onMouseLeave={() => handleMenuHover(null)}
            >
              {item.label}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 w-3 h-3 inline-block ${
                  activeMenu === item.label ? "fa-flip-vertical" : ""
                }`}
              />
              {activeMenu === item.label && (
                <NavigationMenu items={[...item.items]} />
              )}
            </div>
          ) : (
            <Link
              key={item.label}
              to={item.href}
              className={`px-2 ${
                pathname.pathname === item.href
                  ? "underline decoration-logo-main decoration-4 underline-offset-8 text-logo-main"
                  : "text-ocean hover:text-logo-main transition-colors duration-200"
              }`}
            >
              {item.label}
            </Link>
          )
        )}
      </nav>
    </div>
  );
};

export default DesktopNav;
